import { useEffect } from 'react';

const SITE_NAME = 'NextAInsight';

/**
 * Sets document title and meta description for SEO.
 * @param {string} title - Page title (appended with site name)
 * @param {string} description - Meta description content
 */
export default function usePageMeta(title, description) {
  useEffect(() => {
    const prev = document.title;
    document.title = title ? `${title} | ${SITE_NAME}` : SITE_NAME;

    let metaDesc = document.querySelector('meta[name="description"]');
    const hadMeta = !!metaDesc;
    const prevContent = metaDesc?.getAttribute('content') || '';

    if (description) {
      if (!metaDesc) {
        metaDesc = document.createElement('meta');
        metaDesc.setAttribute('name', 'description');
        document.head.appendChild(metaDesc);
      }
      metaDesc.setAttribute('content', description);
    }

    return () => {
      document.title = prev;
      if (metaDesc) {
        if (hadMeta) {
          metaDesc.setAttribute('content', prevContent);
        } else {
          metaDesc.remove();
        }
      }
    };
  }, [title, description]);
}
